var path = '/common/formly/inputs/tpl/html-read-only.html';
var html = "<div dynamic-bind-html={{to.text}}></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/inputs/tpl/html-read-only.html
// module id = 630
// module chunks = 1 3